import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Error de render no capturado:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-white px-4 text-center">
          <div>
            <p className="font-bold text-lg text-slate-900">Algo salió mal.</p>
            <p className="text-slate-500 text-sm mt-1">Intenta recargar la página.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 bg-primary hover:bg-primary-hover text-white font-semibold rounded-lg px-5 py-2.5 transition-colors"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
